module.exports = __webpack_public_path__ + "assets/pencil-blue-60b303.svg";